import { render, staticRenderFns } from "./RelatorioPedido.vue?vue&type=template&id=7b4e3654&scoped=true&"
import script from "./RelatorioPedido.vue?vue&type=script&lang=js&"
export * from "./RelatorioPedido.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioPedido.vue?vue&type=style&index=0&id=7b4e3654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4e3654",
  null
  
)

export default component.exports